@file:OptIn(InternalResourceApi::class)

package com.karyadina.common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.karyadina.common.generated.resources/"

@delegate:ResourceContentHash(1_446_178_525)
internal val Res.string.planner_section_completed: StringResource by lazy {
      StringResource("string:planner_section_completed", "planner_section_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19600, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10812, 45),
      ))
    }

@delegate:ResourceContentHash(2_013_586_516)
internal val Res.string.planner_section_progress: StringResource by lazy {
      StringResource("string:planner_section_progress", "planner_section_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19654, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10858, 48),
      ))
    }

@delegate:ResourceContentHash(1_430_635_046)
internal val Res.string.privacy_policy_desc: StringResource by lazy {
      StringResource("string:privacy_policy_desc", "privacy_policy_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19731, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10907, 71),
      ))
    }

@delegate:ResourceContentHash(231_956_097)
internal val Res.string.privacy_policy_title: StringResource by lazy {
      StringResource("string:privacy_policy_title", "privacy_policy_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19867, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10979, 48),
      ))
    }

@delegate:ResourceContentHash(1_509_017_856)
internal val Res.string.privacy_web_link_desc: StringResource by lazy {
      StringResource("string:privacy_web_link_desc", "privacy_web_link_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19948, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11028, 81),
      ))
    }

@delegate:ResourceContentHash(1_716_450_854)
internal val Res.string.privacy_web_link_title: StringResource by lazy {
      StringResource("string:privacy_web_link_title", "privacy_web_link_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20030, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11110, 58),
      ))
    }

@delegate:ResourceContentHash(1_937_984_586)
internal val Res.string.resize_action_crop: StringResource by lazy {
      StringResource("string:resize_action_crop", "resize_action_crop", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20129, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11169, 34),
      ))
    }

@delegate:ResourceContentHash(1_123_312_524)
internal val Res.string.resize_action_remove: StringResource by lazy {
      StringResource("string:resize_action_remove", "resize_action_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20176, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11204, 36),
      ))
    }

@delegate:ResourceContentHash(1_592_986_725)
internal val Res.string.resize_btn_camera: StringResource by lazy {
      StringResource("string:resize_btn_camera", "resize_btn_camera", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20225, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11241, 33),
      ))
    }

@delegate:ResourceContentHash(1_496_021_111)
internal val Res.string.resize_btn_edit_settings: StringResource by lazy {
      StringResource("string:resize_btn_edit_settings", "resize_btn_edit_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20271, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11275, 72),
      ))
    }

@delegate:ResourceContentHash(68_226_947)
internal val Res.string.resize_btn_gallery: StringResource by lazy {
      StringResource("string:resize_btn_gallery", "resize_btn_gallery", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20436, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11348, 38),
      ))
    }

@delegate:ResourceContentHash(-1_371_419_012)
internal val Res.string.resize_chip_crop: StringResource by lazy {
      StringResource("string:resize_chip_crop", "resize_chip_crop", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20483, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11387, 36),
      ))
    }

@delegate:ResourceContentHash(-1_202_035_753)
internal val Res.string.resize_chip_ratio: StringResource by lazy {
      StringResource("string:resize_chip_ratio", "resize_chip_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20576, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11424, 41),
      ))
    }

@delegate:ResourceContentHash(-28_909_359)
internal val Res.string.resize_error_camera: StringResource by lazy {
      StringResource("string:resize_error_camera", "resize_error_camera", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20646, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11466, 59),
      ))
    }

@delegate:ResourceContentHash(201_739_137)
internal val Res.string.resize_error_permission: StringResource by lazy {
      StringResource("string:resize_error_permission", "resize_error_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20742, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11526, 67),
      ))
    }

@delegate:ResourceContentHash(-1_048_864_818)
internal val Res.string.resize_error_pick: StringResource by lazy {
      StringResource("string:resize_error_pick", "resize_error_pick", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20854, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11594, 53),
      ))
    }

@delegate:ResourceContentHash(-1_544_694_652)
internal val Res.string.resize_error_start: StringResource by lazy {
      StringResource("string:resize_error_start", "resize_error_start", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20944, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11648, 38),
      ))
    }

@delegate:ResourceContentHash(885_291_092)
internal val Res.string.resize_header_custom: StringResource by lazy {
      StringResource("string:resize_header_custom", "resize_header_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 20991, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11687, 48),
      ))
    }

@delegate:ResourceContentHash(-471_311_165)
internal val Res.string.resize_header_presets: StringResource by lazy {
      StringResource("string:resize_header_presets", "resize_header_presets", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21076, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11736, 49),
      ))
    }

@delegate:ResourceContentHash(-463_821_033)
internal val Res.string.resize_label_height: StringResource by lazy {
      StringResource("string:resize_label_height", "resize_label_height", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21162, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11786, 35),
      ))
    }

@delegate:ResourceContentHash(-2_017_706_140)
internal val Res.string.resize_label_quality: StringResource by lazy {
      StringResource("string:resize_label_quality", "resize_label_quality", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21210, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11822, 48),
      ))
    }

@delegate:ResourceContentHash(-1_333_915_891)
internal val Res.string.resize_label_target_size: StringResource by lazy {
      StringResource("string:resize_label_target_size", "resize_label_target_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21283, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11871, 56),
      ))
    }

@delegate:ResourceContentHash(-461_272_290)
internal val Res.string.resize_label_width: StringResource by lazy {
      StringResource("string:resize_label_width", "resize_label_width", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21364, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11928, 34),
      ))
    }

@delegate:ResourceContentHash(898_630_550)
internal val Res.string.resize_placeholder_kb: StringResource by lazy {
      StringResource("string:resize_placeholder_kb", "resize_placeholder_kb", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21415, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11963, 41),
      ))
    }

@delegate:ResourceContentHash(96_696_160)
internal val Res.string.resize_placeholder_px: StringResource by lazy {
      StringResource("string:resize_placeholder_px", "resize_placeholder_px", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21469, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12005, 33),
      ))
    }

@delegate:ResourceContentHash(-539_132_239)
internal val Res.string.resize_preview_original: StringResource by lazy {
      StringResource("string:resize_preview_original", "resize_preview_original", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21503, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12039, 43),
      ))
    }

@delegate:ResourceContentHash(1_720_745_006)
internal val Res.string.resize_preview_result: StringResource by lazy {
      StringResource("string:resize_preview_result", "resize_preview_result", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21547, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12083, 37),
      ))
    }

@delegate:ResourceContentHash(861_770_281)
internal val Res.string.resize_preview_unavailable: StringResource by lazy {
      StringResource("string:resize_preview_unavailable", "resize_preview_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21601, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12121, 62),
      ))
    }

@delegate:ResourceContentHash(-1_202_679_815)
internal val Res.string.resize_status_processing: StringResource by lazy {
      StringResource("string:resize_status_processing", "resize_status_processing", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21732, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12184, 52),
      ))
    }

@delegate:ResourceContentHash(-548_638_970)
internal val Res.string.resize_step1_subtitle: StringResource by lazy {
      StringResource("string:resize_step1_subtitle", "resize_step1_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21809, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12237, 65),
      ))
    }

@delegate:ResourceContentHash(260_267_358)
internal val Res.string.resize_step1_title: StringResource by lazy {
      StringResource("string:resize_step1_title", "resize_step1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 21955, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12303, 42),
      ))
    }

@delegate:ResourceContentHash(1_756_228_141)
internal val Res.string.resize_step2_subtitle: StringResource by lazy {
      StringResource("string:resize_step2_subtitle", "resize_step2_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22018, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12346, 69),
      ))
    }

@delegate:ResourceContentHash(305_887_135)
internal val Res.string.resize_step2_title: StringResource by lazy {
      StringResource("string:resize_step2_title", "resize_step2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22172, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12416, 46),
      ))
    }

@delegate:ResourceContentHash(932_343_504)
internal val Res.string.resize_step3_btn: StringResource by lazy {
      StringResource("string:resize_step3_btn", "resize_step3_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22255, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12463, 40),
      ))
    }

@delegate:ResourceContentHash(82_148_473)
internal val Res.string.resize_step4_subtitle: StringResource by lazy {
      StringResource("string:resize_step4_subtitle", "resize_step4_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22340, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12504, 69),
      ))
    }

@delegate:ResourceContentHash(799_463_772)
internal val Res.string.resize_step4_title: StringResource by lazy {
      StringResource("string:resize_step4_title", "resize_step4_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22482, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12574, 34),
      ))
    }

@delegate:ResourceContentHash(966_465_672)
internal val Res.string.resize_success_message: StringResource by lazy {
      StringResource("string:resize_success_message", "resize_success_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22533, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12609, 70),
      ))
    }

@delegate:ResourceContentHash(2_022_457_542)
internal val Res.string.resize_tip_ratio: StringResource by lazy {
      StringResource("string:resize_tip_ratio", "resize_tip_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22656, 284),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12680, 108),
      ))
    }

@delegate:ResourceContentHash(1_956_089_975)
internal val Res.string.resize_tool_subtitle: StringResource by lazy {
      StringResource("string:resize_tool_subtitle", "resize_tool_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 22941, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12789, 56),
      ))
    }

@delegate:ResourceContentHash(-25_556_529)
internal val Res.string.resize_tool_title: StringResource by lazy {
      StringResource("string:resize_tool_title", "resize_tool_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23074, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12846, 45),
      ))
    }

@delegate:ResourceContentHash(-474_626_826)
internal val Res.string.review_all_caught_up: StringResource by lazy {
      StringResource("string:review_all_caught_up", "review_all_caught_up", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23148, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12892, 64),
      ))
    }

@delegate:ResourceContentHash(-132_895_095)
internal val Res.string.review_completed_prefix: StringResource by lazy {
      StringResource("string:review_completed_prefix", "review_completed_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23253, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12957, 51),
      ))
    }

@delegate:ResourceContentHash(97_354_439)
internal val Res.string.review_completed_suffix: StringResource by lazy {
      StringResource("string:review_completed_suffix", "review_completed_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23337, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13009, 55),
      ))
    }

@delegate:ResourceContentHash(155_635_342)
internal val Res.string.review_highlights: StringResource by lazy {
      StringResource("string:review_highlights", "review_highlights", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23425, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13065, 41),
      ))
    }

@delegate:ResourceContentHash(847_278_318)
internal val Res.string.review_more_format: StringResource by lazy {
      StringResource("string:review_more_format", "review_more_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23487, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13107, 46),
      ))
    }

@delegate:ResourceContentHash(-859_687_741)
internal val Res.string.review_needs_attention: StringResource by lazy {
      StringResource("string:review_needs_attention", "review_needs_attention", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23538, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13154, 50),
      ))
    }

@delegate:ResourceContentHash(348_534_869)
internal val Res.string.review_no_completed: StringResource by lazy {
      StringResource("string:review_no_completed", "review_no_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23605, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13205, 75),
      ))
    }

@delegate:ResourceContentHash(1_190_112_487)
internal val Res.string.review_plan_next: StringResource by lazy {
      StringResource("string:review_plan_next", "review_plan_next", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23769, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13281, 44),
      ))
    }

@delegate:ResourceContentHash(-1_461_763_092)
internal val Res.string.review_title: StringResource by lazy {
      StringResource("string:review_title", "review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23866, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13326, 40),
      ))
    }

@delegate:ResourceContentHash(-385_527_008)
internal val Res.string.screen_transition: StringResource by lazy {
      StringResource("string:screen_transition", "screen_transition", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 23955, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13367, 49),
      ))
    }

@delegate:ResourceContentHash(1_210_522_386)
internal val Res.string.settings_always_show: StringResource by lazy {
      StringResource("string:settings_always_show", "settings_always_show", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24005, 100),
      ))
    }

@delegate:ResourceContentHash(-224_055_192)
internal val Res.string.settings_app_color: StringResource by lazy {
      StringResource("string:settings_app_color", "settings_app_color", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24106, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13417, 38),
      ))
    }

@delegate:ResourceContentHash(-1_609_742_615)
internal val Res.string.settings_appearance: StringResource by lazy {
      StringResource("string:settings_appearance", "settings_appearance", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24157, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13456, 43),
      ))
    }

@delegate:ResourceContentHash(-1_498_681_180)
internal val Res.string.settings_auto: StringResource by lazy {
      StringResource("string:settings_auto", "settings_auto", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24209, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13500, 29),
      ))
    }

@delegate:ResourceContentHash(-725_778_206)
internal val Res.string.settings_change_persona: StringResource by lazy {
      StringResource("string:settings_change_persona", "settings_change_persona", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24251, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13530, 51),
      ))
    }

@delegate:ResourceContentHash(-1_720_482_030)
internal val Res.string.settings_customize_home: StringResource by lazy {
      StringResource("string:settings_customize_home", "settings_customize_home", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24347, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13582, 67),
      ))
    }

@delegate:ResourceContentHash(1_962_768_542)
internal val Res.string.settings_daily_focus_desc: StringResource by lazy {
      StringResource("string:settings_daily_focus_desc", "settings_daily_focus_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24503, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13650, 77),
      ))
    }

@delegate:ResourceContentHash(1_918_387_731)
internal val Res.string.settings_daily_focus_title: StringResource by lazy {
      StringResource("string:settings_daily_focus_title", "settings_daily_focus_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24649, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13728, 58),
      ))
    }

@delegate:ResourceContentHash(274_074_470)
internal val Res.string.settings_desc: StringResource by lazy {
      StringResource("string:settings_desc", "settings_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24740, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13787, 33),
      ))
    }

@delegate:ResourceContentHash(-85_071_286)
internal val Res.string.settings_doc_tools_desc: StringResource by lazy {
      StringResource("string:settings_doc_tools_desc", "settings_doc_tools_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24794, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13821, 87),
      ))
    }

@delegate:ResourceContentHash(-1_288_628_035)
internal val Res.string.settings_doc_tools_title: StringResource by lazy {
      StringResource("string:settings_doc_tools_title", "settings_doc_tools_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 24958, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13909, 64),
      ))
    }

@delegate:ResourceContentHash(519_334_176)
internal val Res.string.settings_language_desc: StringResource by lazy {
      StringResource("string:settings_language_desc", "settings_language_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25063, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13974, 66),
      ))
    }

@delegate:ResourceContentHash(1_136_603_740)
internal val Res.string.settings_language_title: StringResource by lazy {
      StringResource("string:settings_language_title", "settings_language_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25130, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14041, 47),
      ))
    }

@delegate:ResourceContentHash(59_232_606)
internal val Res.string.settings_show_all: StringResource by lazy {
      StringResource("string:settings_show_all", "settings_show_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25501, 85),
      ))
    }

@delegate:ResourceContentHash(1_916_706_177)
internal val Res.string.settings_show_all_desc: StringResource by lazy {
      StringResource("string:settings_show_all_desc", "settings_show_all_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25190, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14089, 98),
      ))
    }

@delegate:ResourceContentHash(1_177_990_267)
internal val Res.string.settings_show_all_title: StringResource by lazy {
      StringResource("string:settings_show_all_title", "settings_show_all_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25409, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14188, 51),
      ))
    }

@delegate:ResourceContentHash(1_227_791_480)
internal val Res.string.settings_theme_mode: StringResource by lazy {
      StringResource("string:settings_theme_mode", "settings_theme_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25587, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14240, 43),
      ))
    }

@delegate:ResourceContentHash(1_754_697_291)
internal val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25643, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14284, 46),
      ))
    }

@delegate:ResourceContentHash(590_609_853)
internal val Res.string.settings_weekly_review_desc: StringResource by lazy {
      StringResource("string:settings_weekly_review_desc", "settings_weekly_review_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25734, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14331, 87),
      ))
    }

@delegate:ResourceContentHash(-1_461_763_092)
internal val Res.string.settings_weekly_review_title: StringResource by lazy {
      StringResource("string:settings_weekly_review_title", "settings_weekly_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25926, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14419, 56),
      ))
    }

@delegate:ResourceContentHash(920_044_045)
internal val Res.string.stats_streak: StringResource by lazy {
      StringResource("string:stats_streak", "stats_streak", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26031, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14476, 28),
      ))
    }

@delegate:ResourceContentHash(-1_750_716_492)
internal val Res.string.stats_title: StringResource by lazy {
      StringResource("string:stats_title", "stats_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26076, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14505, 43),
      ))
    }

@delegate:ResourceContentHash(679_311_906)
internal val Res.string.stats_today: StringResource by lazy {
      StringResource("string:stats_today", "stats_today", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26160, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14549, 27),
      ))
    }

@delegate:ResourceContentHash(-87_458_893)
internal val Res.string.stats_total: StringResource by lazy {
      StringResource("string:stats_total", "stats_total", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26188, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14577, 27),
      ))
    }

@delegate:ResourceContentHash(-1_461_353_482)
internal val Res.string.stats_week: StringResource by lazy {
      StringResource("string:stats_week", "stats_week", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26220, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14605, 26),
      ))
    }

@delegate:ResourceContentHash(-1_069_503_228)
internal val Res.string.subject_weekly_progress: StringResource by lazy {
      StringResource("string:subject_weekly_progress", "subject_weekly_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26263, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14632, 51),
      ))
    }

@delegate:ResourceContentHash(1_673_319_448)
internal val Res.string.support_dev_desc: StringResource by lazy {
      StringResource("string:support_dev_desc", "support_dev_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26359, 356),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14684, 152),
      ))
    }

@delegate:ResourceContentHash(1_307_330_056)
internal val Res.string.support_dev_scan_qr: StringResource by lazy {
      StringResource("string:support_dev_scan_qr", "support_dev_scan_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26716, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14837, 59),
      ))
    }

@delegate:ResourceContentHash(-1_566_650_033)
internal val Res.string.support_dev_show_qr: StringResource by lazy {
      StringResource("string:support_dev_show_qr", "support_dev_show_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26860, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14897, 47),
      ))
    }

@delegate:ResourceContentHash(-1_927_270_378)
internal val Res.string.support_dev_title: StringResource by lazy {
      StringResource("string:support_dev_title", "support_dev_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26928, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14945, 53),
      ))
    }

@delegate:ResourceContentHash(-1_375_167_822)
internal val Res.string.support_dev_upi: StringResource by lazy {
      StringResource("string:support_dev_upi", "support_dev_upi", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27030, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14999, 55),
      ))
    }

@delegate:ResourceContentHash(991_529_990)
internal val Res.string.tab_sessions: StringResource by lazy {
      StringResource("string:tab_sessions", "tab_sessions", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27118, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15055, 32),
      ))
    }

@delegate:ResourceContentHash(1_242_638_924)
internal val Res.string.tab_subjects: StringResource by lazy {
      StringResource("string:tab_subjects", "tab_subjects", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27155, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15088, 32),
      ))
    }

@delegate:ResourceContentHash(55_353_225)
internal val Res.string.task_category_assignment: StringResource by lazy {
      StringResource("string:task_category_assignment", "task_category_assignment", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27192, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15121, 48),
      ))
    }

@delegate:ResourceContentHash(-1_301_852_953)
internal val Res.string.task_category_exam_prep: StringResource by lazy {
      StringResource("string:task_category_exam_prep", "task_category_exam_prep", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27261, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15170, 43),
      ))
    }

@delegate:ResourceContentHash(-1_967_534_111)
internal val Res.string.task_category_label: StringResource by lazy {
      StringResource("string:task_category_label", "task_category_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27349, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15214, 39),
      ))
    }

@delegate:ResourceContentHash(-2_083_011_607)
internal val Res.string.task_category_other: StringResource by lazy {
      StringResource("string:task_category_other", "task_category_other", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27401, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15254, 35),
      ))
    }

@delegate:ResourceContentHash(-1_737_868_743)
internal val Res.string.task_category_practice: StringResource by lazy {
      StringResource("string:task_category_practice", "task_category_practice", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27445, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15290, 42),
      ))
    }

@delegate:ResourceContentHash(-77_284_815)
internal val Res.string.task_category_project: StringResource by lazy {
      StringResource("string:task_category_project", "task_category_project", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27500, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15333, 41),
      ))
    }

@delegate:ResourceContentHash(922_536_968)
internal val Res.string.task_category_reading: StringResource by lazy {
      StringResource("string:task_category_reading", "task_category_reading", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27566, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15375, 41),
      ))
    }

@delegate:ResourceContentHash(906_026_202)
internal val Res.string.task_category_revision: StringResource by lazy {
      StringResource("string:task_category_revision", "task_category_revision", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27612, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15417, 42),
      ))
    }

@delegate:ResourceContentHash(-795_026_135)
internal val Res.string.task_create_title: StringResource by lazy {
      StringResource("string:task_create_title", "task_create_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27671, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15460, 45),
      ))
    }

@delegate:ResourceContentHash(1_107_888_884)
internal val Res.string.task_deadline_label: StringResource by lazy {
      StringResource("string:task_deadline_label", "task_deadline_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27753, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15506, 43),
      ))
    }

@delegate:ResourceContentHash(827_198_607)
internal val Res.string.task_desc_label: StringResource by lazy {
      StringResource("string:task_desc_label", "task_desc_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27865, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15550, 39),
      ))
    }

@delegate:ResourceContentHash(827_198_607)
internal val Res.string.task_detail_description: StringResource by lazy {
      StringResource("string:task_detail_description", "task_detail_description", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27909, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15590, 47),
      ))
    }

@delegate:ResourceContentHash(1_909_020_078)
internal val Res.string.task_detail_due_date: StringResource by lazy {
      StringResource("string:task_detail_due_date", "task_detail_due_date", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27961, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15638, 40),
      ))
    }

@delegate:ResourceContentHash(-1_488_103_604)
internal val Res.string.task_detail_overdue: StringResource by lazy {
      StringResource("string:task_detail_overdue", "task_detail_overdue", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28030, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15679, 39),
      ))
    }

@delegate:ResourceContentHash(-2_063_695_026)
internal val Res.string.task_detail_subject: StringResource by lazy {
      StringResource("string:task_detail_subject", "task_detail_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28086, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15719, 39),
      ))
    }

@delegate:ResourceContentHash(2_016_078_292)
internal val Res.string.task_edit_title: StringResource by lazy {
      StringResource("string:task_edit_title", "task_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28134, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15759, 35),
      ))
    }

@delegate:ResourceContentHash(-1_076_669_044)
internal val Res.string.task_empty_desc: StringResource by lazy {
      StringResource("string:task_empty_desc", "task_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28226, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15795, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("planner_section_completed", Res.string.planner_section_completed)
  map.put("planner_section_progress", Res.string.planner_section_progress)
  map.put("privacy_policy_desc", Res.string.privacy_policy_desc)
  map.put("privacy_policy_title", Res.string.privacy_policy_title)
  map.put("privacy_web_link_desc", Res.string.privacy_web_link_desc)
  map.put("privacy_web_link_title", Res.string.privacy_web_link_title)
  map.put("resize_action_crop", Res.string.resize_action_crop)
  map.put("resize_action_remove", Res.string.resize_action_remove)
  map.put("resize_btn_camera", Res.string.resize_btn_camera)
  map.put("resize_btn_edit_settings", Res.string.resize_btn_edit_settings)
  map.put("resize_btn_gallery", Res.string.resize_btn_gallery)
  map.put("resize_chip_crop", Res.string.resize_chip_crop)
  map.put("resize_chip_ratio", Res.string.resize_chip_ratio)
  map.put("resize_error_camera", Res.string.resize_error_camera)
  map.put("resize_error_permission", Res.string.resize_error_permission)
  map.put("resize_error_pick", Res.string.resize_error_pick)
  map.put("resize_error_start", Res.string.resize_error_start)
  map.put("resize_header_custom", Res.string.resize_header_custom)
  map.put("resize_header_presets", Res.string.resize_header_presets)
  map.put("resize_label_height", Res.string.resize_label_height)
  map.put("resize_label_quality", Res.string.resize_label_quality)
  map.put("resize_label_target_size", Res.string.resize_label_target_size)
  map.put("resize_label_width", Res.string.resize_label_width)
  map.put("resize_placeholder_kb", Res.string.resize_placeholder_kb)
  map.put("resize_placeholder_px", Res.string.resize_placeholder_px)
  map.put("resize_preview_original", Res.string.resize_preview_original)
  map.put("resize_preview_result", Res.string.resize_preview_result)
  map.put("resize_preview_unavailable", Res.string.resize_preview_unavailable)
  map.put("resize_status_processing", Res.string.resize_status_processing)
  map.put("resize_step1_subtitle", Res.string.resize_step1_subtitle)
  map.put("resize_step1_title", Res.string.resize_step1_title)
  map.put("resize_step2_subtitle", Res.string.resize_step2_subtitle)
  map.put("resize_step2_title", Res.string.resize_step2_title)
  map.put("resize_step3_btn", Res.string.resize_step3_btn)
  map.put("resize_step4_subtitle", Res.string.resize_step4_subtitle)
  map.put("resize_step4_title", Res.string.resize_step4_title)
  map.put("resize_success_message", Res.string.resize_success_message)
  map.put("resize_tip_ratio", Res.string.resize_tip_ratio)
  map.put("resize_tool_subtitle", Res.string.resize_tool_subtitle)
  map.put("resize_tool_title", Res.string.resize_tool_title)
  map.put("review_all_caught_up", Res.string.review_all_caught_up)
  map.put("review_completed_prefix", Res.string.review_completed_prefix)
  map.put("review_completed_suffix", Res.string.review_completed_suffix)
  map.put("review_highlights", Res.string.review_highlights)
  map.put("review_more_format", Res.string.review_more_format)
  map.put("review_needs_attention", Res.string.review_needs_attention)
  map.put("review_no_completed", Res.string.review_no_completed)
  map.put("review_plan_next", Res.string.review_plan_next)
  map.put("review_title", Res.string.review_title)
  map.put("screen_transition", Res.string.screen_transition)
  map.put("settings_always_show", Res.string.settings_always_show)
  map.put("settings_app_color", Res.string.settings_app_color)
  map.put("settings_appearance", Res.string.settings_appearance)
  map.put("settings_auto", Res.string.settings_auto)
  map.put("settings_change_persona", Res.string.settings_change_persona)
  map.put("settings_customize_home", Res.string.settings_customize_home)
  map.put("settings_daily_focus_desc", Res.string.settings_daily_focus_desc)
  map.put("settings_daily_focus_title", Res.string.settings_daily_focus_title)
  map.put("settings_desc", Res.string.settings_desc)
  map.put("settings_doc_tools_desc", Res.string.settings_doc_tools_desc)
  map.put("settings_doc_tools_title", Res.string.settings_doc_tools_title)
  map.put("settings_language_desc", Res.string.settings_language_desc)
  map.put("settings_language_title", Res.string.settings_language_title)
  map.put("settings_show_all", Res.string.settings_show_all)
  map.put("settings_show_all_desc", Res.string.settings_show_all_desc)
  map.put("settings_show_all_title", Res.string.settings_show_all_title)
  map.put("settings_theme_mode", Res.string.settings_theme_mode)
  map.put("settings_title", Res.string.settings_title)
  map.put("settings_weekly_review_desc", Res.string.settings_weekly_review_desc)
  map.put("settings_weekly_review_title", Res.string.settings_weekly_review_title)
  map.put("stats_streak", Res.string.stats_streak)
  map.put("stats_title", Res.string.stats_title)
  map.put("stats_today", Res.string.stats_today)
  map.put("stats_total", Res.string.stats_total)
  map.put("stats_week", Res.string.stats_week)
  map.put("subject_weekly_progress", Res.string.subject_weekly_progress)
  map.put("support_dev_desc", Res.string.support_dev_desc)
  map.put("support_dev_scan_qr", Res.string.support_dev_scan_qr)
  map.put("support_dev_show_qr", Res.string.support_dev_show_qr)
  map.put("support_dev_title", Res.string.support_dev_title)
  map.put("support_dev_upi", Res.string.support_dev_upi)
  map.put("tab_sessions", Res.string.tab_sessions)
  map.put("tab_subjects", Res.string.tab_subjects)
  map.put("task_category_assignment", Res.string.task_category_assignment)
  map.put("task_category_exam_prep", Res.string.task_category_exam_prep)
  map.put("task_category_label", Res.string.task_category_label)
  map.put("task_category_other", Res.string.task_category_other)
  map.put("task_category_practice", Res.string.task_category_practice)
  map.put("task_category_project", Res.string.task_category_project)
  map.put("task_category_reading", Res.string.task_category_reading)
  map.put("task_category_revision", Res.string.task_category_revision)
  map.put("task_create_title", Res.string.task_create_title)
  map.put("task_deadline_label", Res.string.task_deadline_label)
  map.put("task_desc_label", Res.string.task_desc_label)
  map.put("task_detail_description", Res.string.task_detail_description)
  map.put("task_detail_due_date", Res.string.task_detail_due_date)
  map.put("task_detail_overdue", Res.string.task_detail_overdue)
  map.put("task_detail_subject", Res.string.task_detail_subject)
  map.put("task_edit_title", Res.string.task_edit_title)
  map.put("task_empty_desc", Res.string.task_empty_desc)
}
